/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { useContext } from 'react'

import { ReactComponent as SurveyIcon } from '../../assets/icons/survey.svg'
import { ReactComponent as FolderIcon } from '../../assets/icons/folder.svg'
import { ReactComponent as FeedbackIcon } from '../../assets/icons/feedback.svg'

import { Context } from '../../context'
import { VIEWS } from '../../constants'
import Link from './Link'

const { SANDBOX, FEEDBACK, SURVEYS, SETTINGS } = VIEWS

const mainCss = css`
  width: 200px;
  height: 100vh;
  background-color: white;
  border-right: 1px solid #d8dee5;

  @media (max-width: 855px) {
    height: 200px;
    width: 100vw;
  }

  .list {
    display: flex;
    flex-direction: column;

    @media (max-width: 855px) {
      flex-direction: row;
    }

    @media (min-width: 855px) {
      height: 100%;

      > div {
        border-bottom: 1px solid #d8dee5;
      }
    }
  }

  .name {
    width: 100%;
    height: 55px;
    display: flex;
    align-items: center;

    @media (max-width: 855px) {
      display: none;
    }

    > span {
      margin-left: 10px;
    }
  }
`

const Nav = () => {
  const {
    view,
    redirectToSandbox,
    redirectToSurveys,
    redirectToFeedback,
    resetSandboxSurvey,
    setIsTemplate,
  } = useContext(Context)

  return (
    <div css={mainCss}>
      <div className="list">
        <div className="name">
          <span>Surveys</span>
        </div>
        <Link
          onClick={() => {
            resetSandboxSurvey()
            setIsTemplate()
            redirectToSandbox()
          }}
          isActive={view === SANDBOX}
          name="sandbox"
          icon={SurveyIcon}
        />
        <Link
          onClick={redirectToSurveys}
          isActive={view === SURVEYS}
          name="surveys"
          icon={FolderIcon}
        />
        <Link
          onClick={redirectToFeedback}
          isActive={view === FEEDBACK}
          name="feedback"
          icon={FeedbackIcon}
        />
      </div>
    </div>
  )
}

export default Nav
